import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListEmployeeStart,
  getListEmployeeSuccess,
  getListEmployeeFailed,
} from "../redux/getListEmployee";
import { getListEmployeeApi } from "core/http/service/timeKeeping";
import { selectNameEmployee } from "../redux/selector";

function* getListEmployeeWork() {
  const name = yield select(selectNameEmployee);
  try {
    const res = yield call(getListEmployeeApi, { name });

    yield put({
      type: getListEmployeeSuccess.type,
      payload: res?.map((it) => ({
        label: `${it?.name} - ${it?.positionName}`,
        value: it?.employeeCode,
      })),
    });
  } catch (error: any) {
    yield put({
      type: getListEmployeeFailed.type,
    });
  }
}

function* watchGetListEmployee() {
  yield takeLatest(getListEmployeeStart.type, getListEmployeeWork);
}

export default function* getListEmployeeSaga() {
  yield all([watchGetListEmployee()]);
}
